import i18n from '@/i18n';
import { OANDA_LANGUAGES } from '@/constants/locale';
import ClientZoneUrls from '@/constants/client-zone-urls';
import { UtilityHelper } from '@/helpers/UtilityHelper';
import EnviromentUrls from '@/constants/enviroment-urls';
import { CountryHelper } from '@/helpers/CountryHelper';

export class UrlHelper {
    /**
     * Returns first found value for passed name (null if not found)
     * @param name
     * @return string | null
     */
    public static getQueryParam(name: string): string | null {
        const pairs = location.search.substring(1).split('&');
        let value = null;

        for (let pair of pairs) {
            pair = pair.split('=') as any;

            if (pair[0] === name) {
                value = pair[1];
            }
        }

        return value;
    }

    public static getHubUrl(): string {
        return process.env.NODE_ENV == 'production'
            ? ClientZoneUrls.HUB.PRODUCTION.concat(
                  'eu-' + i18n.global.locale.value
              )
            : ClientZoneUrls.HUB.TEST.concat('eu-' + i18n.global.locale.value);
    }

    public static getRedirectUrlByResidence(country: string): string {
        const environment = this.getEnvironmentUrlList();
        let url = environment.OANDA;
        if (!CountryHelper.isEuropeanCountry(country)) {
            url = 'https://www.oanda.com/apply/';
        } else {
            const language = i18n.global.locale.value.toUpperCase();
            const redirect = country.toLowerCase();

            if (UtilityHelper.isOandaPath()) {
                if (OANDA_LANGUAGES.indexOf(redirect.toUpperCase()) > -1) {
                    url =
                        environment.OANDA.replace('{lang}', redirect) +
                        '?lang=' +
                        redirect;
                } else {
                    if (redirect === 'pl') {
                        url = environment.PL + '?lang=' + redirect;
                    } else {
                        url =
                            environment.OTHER.replace('{lang}', redirect) +
                            '?lang=' +
                            redirect;
                    }
                }
            } else {
                if (OANDA_LANGUAGES.indexOf(redirect.toUpperCase()) > -1) {
                    url = url.replace('{lang}', redirect) + '?lang=' + redirect;
                } else {
                    if (redirect === 'pl') {
                        url = environment.PL + '?lang=' + redirect;
                    } else if (
                        redirect !== 'pl' &&
                        language.toLowerCase() === 'pl'
                    ) {
                        url =
                            environment.OTHER.replace('{lang}', redirect) +
                            '?lang=' +
                            redirect;
                    } else {
                        url =
                            environment.OTHER.replace('{lang}', redirect) +
                            '?lang=' +
                            redirect;
                    }
                }
            }
        }

        return url;
    }

    public static getEnvironmentUrlList() {
        let lists = EnviromentUrls.PRODUCTION;
        if (window.location.host.includes('localhost:80')) {
            lists = EnviromentUrls.LOCAL;
        } else if (process.env.NODE_ENV === 'development') {
            lists = EnviromentUrls.DEVELOPMENT;
        }

        return lists;
    }

    public static getCookiesDomainUrl() {
        let cookieDomain = '.tms.pl';

        if (
            location.host.indexOf('test.tms.pl') > -1 ||
            location.host.indexOf('localhost') !== -1
        ) {
            cookieDomain = '.' + location.host;
        } else {
            switch (location.host) {
                case 'www.oanda.com': {
                    cookieDomain = '.oanda.com';
                    break;
                }
                case 'www.tmsbrokers.com': {
                    cookieDomain = '.tmsbrokers.com';
                }
                default: {
                    cookieDomain = '.tms.pl';
                }
            }
        }
        return cookieDomain;
    }
}
